import { routerMiddleware } from 'react-router-redux';
import { applyMiddleware } from 'redux';

// App Service
import history from '../services/History';

// App Middlewares
import imageDataCheckRouteInterceptor from './ImageDataCheckRouteInterceptor';

/**
 * Middleware chain.
 * - Build the middleware for intercepting and dispatching navigation actions
 * - If you add other middlewares:
 * applyMiddleware(routerMiddleware(), ...others)
 */
const enhancements = applyMiddleware(routerMiddleware(history), imageDataCheckRouteInterceptor);

export default enhancements;



// WEBPACK FOOTER //
// ./src/middlewares/MiddlewareContainer.js